import IMask from 'imask';

document.addEventListener("DOMContentLoaded", function(){
    document.querySelectorAll('input[data-date-mask]').forEach((input : HTMLElement) => {
      IMask(input, {
        mask: Date,
        pattern: 'd{/}`m{/}`Y',
        blocks: {
          d: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31,
            maxLength: 2,
          },
          m: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 2,
          },
          Y: {
            mask: IMask.MaskedRange,
            from: 1900,
            to: 2100,
            maxLength: 4,
          }
        },
        format: function (date) {
          var day = date.getDate();
          var month = date.getMonth() + 1;
          var year = date.getFullYear();
      
          var dayString = (day < 10) ? "0" + day : day;
          var monthString = (month < 10) ? "0" + month : month;
          return [dayString, monthString, year].join('/');
        },
        parse: function (str) {
          var yearMonthDay = str.split('/');
          return new Date(parseInt(yearMonthDay[2]), parseInt(yearMonthDay[1]) - 1, parseInt(yearMonthDay[0]));
        },
      })
    });
  });